import { Controller } from "@hotwired/stimulus"
import { showToast } from "../kit_toast"

export default class extends Controller {
    static targets = ["dialog", "tokenField"]
    static values = { url: String }

    async getToken(event) {
        event.preventDefault()

        try {
            const response = await fetch(this.urlValue, {
                method: 'POST',
                headers: {
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
                    'Accept': 'application/json'
                }
            })

            const { token } = await response.json()
            this.tokenFieldTarget.value = token
            this.dialogTarget.showModal()
        } catch (error) {
            console.error('Error:', error)
        }
    }

    closeModal() {
        this.dialogTarget.close()
    }

    closeOnBackdrop(event) {
        if (event.target === this.dialogTarget) this.dialogTarget.close()
    }

    copyToClipboard() {
        this.tokenFieldTarget.select()
        navigator.clipboard.writeText(this.tokenFieldTarget.value)
            .then(() => showToast("success", "Токен скопирован в буфер обмена"))
            .catch(() => showToast("error", "Не удалось скопировать токен"))
    }

    shareToken() {
        const url = `https://kibet.rocket.tatar/service/auth?token=${this.tokenFieldTarget.value}`

        if (navigator.share) {
            navigator.share({ url })
                .catch((error) => { if (error.name !== 'AbortError') showToast("error", "Не удалось поделиться") })
        } else {
            navigator.clipboard.writeText(url)
                .then(() => showToast("success", "Ссылка скопирована в буфер обмена"))
                .catch(() => showToast("error", "Не удалось скопировать ссылку"))
        }
    }
}
